module.exports = __webpack_public_path__ + "static/backgroundBlack-ffa657f232bbc69aaf93e4f0480bea09.png";